module.exports = __webpack_public_path__ + "img/reject.ccb81467.png";